import { createApi } from '@/api/modules/utils'

const baseUrl = '/draft_box'
const api = createApi(baseUrl)

// 用户相关API
export const draftBoxApi = {
  insert: api('insert', 'post'),
  list: api('list', 'get'),
  detail: api('detail', 'get'),
  update: api('update', 'post'),
  delete: api('delete', 'get'),
  select: api('select', 'get'),
}